import React from 'react';
import market from "@/public/svg/food-market.svg"
import { FaRegClock } from 'react-icons/fa';

export interface StoreInfo {
    id: number,
    name: string,
    street: string,
    city: string,
    zip: string,
    latitude: number,
    longitude: number,
    openingHours?: string
}

const StoreCard: React.FC<{ store: StoreInfo; comingSoon?: boolean }> = ({ store, comingSoon = false }) => {
    return (
        <div className={`${comingSoon ? "bg-primaryLight" : "bg-secondaryLight"} rounded-xl shadow p-6 hover:shadow-lg transition w-full flex items-start gap-4`}>
            <img src={market} alt="Market Icon" loading="lazy" className="w-6 h-6 mt-1 flex-shrink-0" />

            <div>
                <h3 className="text-xl font-semibold mb-1">{store.name}</h3>
                <p className="text-sm text-gray-600 mb-2">{store.street}</p>
                <p className="text-sm text-gray-600 mb-2">
                    {store.zip} {store.city}
                </p>
                {!comingSoon && store.openingHours && (
                    <p className="mt-3 inline-flex items-center gap-2 rounded-full bg-white/70 px-3 py-1.5 text-sm font-medium text-primaryDark">
                        <FaRegClock className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
                        {store.openingHours}
                    </p>
                )}
            </div>
        </div>

    );
};

export default StoreCard;
